import { SvgSpinnersBarsScale } from './assets/icons/layout/SvgSpinnersBarsScale';
export default () => {
  return (
    <div className="flex justify-center items-center pt-[40vh]">
      <SvgSpinnersBarsScale className="text-primary text-2xl" />
    </div>
  );
};
